import { Environment } from '@/constants/environments';

export const getSourceForRequestDemoCRM = (environment: Environment) => {
	switch (environment) {
		case Environment.Prod:
			return 'Запрос демонстрации с прода';
		case Environment.Demo:
			return 'Запрос демонстрации с демо';
		case Environment.Test:
			return 'Запрос демонстрации с теста';
		default:
			return;
	}
};
